var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{style:({ fontSize: `${_vm.mainFontSize}px` }),domProps:{"innerHTML":_vm._s(_setup.formattedCurrency)}})
}
var staticRenderFns = []

export { render, staticRenderFns }